var enGB = {
  locale: 'en_GB',
  direction: 'ltr',
  date: {
    defaultFormat: {
      week: 'WW/YYYY',
      date: 'DD/MM/YYYY',
      month: 'MM/YYYY',
      year: 'YYYY',
      time: 'HH:mm:ss',
      dateTime: 'DD/MM/YYYY HH:mm:ss'
    },
    startDay: 0,
    monthList: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
    shortMonthList: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
    dayList: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
    shortDayList: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
    shortestDayList: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa']
  },
  'dynamic-date': {
    day: 'day',
    week: 'week',
    month: 'month',
    quarter: 'quarter',
    year: 'year',
    before: '${value} ${unit}(s) before'
  },
  'auto-complete.placeholder': 'Please select',
  'auto-complete.empty': 'No Data',
  'cascader.titles': ['Level 1', 'Level 2', 'Level 3', 'Level 4', 'Level 5', 'Level 6', 'Level 7', 'Level 8'],
  'cascader.empty': 'No Data',
  'cascader.search': 'Please enter your search term',
  'color.custom': 'Customize Color',
  'date.year': '${year}',
  'date.month': 'Month',
  'date.week': 'Week',
  'date.month-first': true,
  'date-picker.start': 'Start Date',
  'date-picker.end': 'End Date',
  'date-picker.placeholder': 'Select a Date',
  'date-picker.cancel': 'Cancel',
  'date-picker.apply': 'Apply',
  'date-picker.invalid-range': 'The time range selected exceeds the selectable range. Please select a  valid one.',
  'date-comparison.mom': 'Period over Period',
  'date-comparison.yoy': 'YoY',
  'date-comparison.placeholder': 'Start Time - End Time',
  'date-comparison.error-source': 'Select a start time for the comparison',
  'date-comparison.error-target': 'Select an end time for the comparison',
  'date-comparison.compare': 'Comparison',
  'date-comparison.compare-text': 'VS',
  'dynamic-date.customize': 'Customize',
  'dynamic-date.date-preview': 'Date Preview',
  'dynamic-date.dynamic-date': 'Dynamic Date',
  'dynamic-date.fixed-date': 'Fixed Date',
  'dynamic-date.interval': 'Interval',
  'empty.text': 'No Data',
  'input.placeholder': 'Please enter',
  'textarea.placeholder': 'Please enter',
  'list-viewer.empty': 'No Data',
  'modal.cancel': 'Cancel',
  'modal.ok': 'Confirm',
  'pager.jump': 'Redirect',
  'pager.total': '${total} Records in Total',
  'pager.size': '${count}Lines/Page',
  'pager.page.placeholder': 'Please enter',
  'popover.cancel': 'Cancel',
  'popover.ok': 'Confirm',
  'schedule.selected': 'Time selected',
  'schedule.clear': 'Clear',
  'schedule.separator': ',',
  'schedule.title': 'Date/Time',
  'select.search.placeholder': 'Please enter',
  'select.empty': 'No Data',
  'select.selected': 'Selected',
  'select.selected-count': '${count} items selected',
  'select.select-all': 'Select all',
  'select.placeholder': 'Please select',
  'select.clear': 'Clear',
  'tabs.more': 'More',
  'table.emptyText': 'No Data',
  'table.filter.reset': 'Reset',
  'table.filter.confirm': 'Confirm',
  'transfer.empty': 'No relevant data available',
  'transfer.placeholder': 'Please enter',
  'transfer.source': 'Source List',
  'transfer.target': 'Target List',
  'tree.empty': 'No relevant results found',
  'tree-select.placeholder': 'Please enter',
  'tree-select.empty': 'No Data',
  'time-picker.placeholder': 'Select a Time',
  'time-range-picker.placeholder': 'Start Time - End time',
  'upload.error.overflow-count': 'Exceeded the maximum number of files',
  'upload.click': 'Click to upload',
  'upload.drop': 'Drag files here or ',
  'date-time-picker.now': 'Now',
  'date-time-picker.ok': 'Confirm',
  'date-time-picker.date': 'Choose date',
  'date-time-picker.time': 'Choose time',
  'date-time-picker.placeholder': 'Please enter',
  'date-time-picker.start': 'Select start date and time',
  'date-time-picker.end': 'Select end date and time',
  'image-view.next': 'Next',
  'image-view.prev': 'Prev',
  'image-view.zoom-in': 'Zoom In',
  'image-view.zoom-out': 'Zoom Out',
  'image-view.zoom-to-origin': 'Original',
  'image-view.zoom-to-fit': 'Fit',
  'image-view.rotate': 'Rotate'
};
export default enGB;